export default __webpack_public_path__ + "static/media/(49).95e40bbb.jpg";